import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Fade } from "react-reveal";
import {
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import Steper from "Component/Steper/Steper";

// modals
import Selecttokenmod from "Component/Modals/Selecttokenmod";
import Processingmodal from "Component/Modals/Processingmodal";


const Sellkyc = (props) => {
  const navigate = useNavigate();
  const [selecttoken, setselectoken] = useState(false);
  const [processingmodal, setprocessingmodal] = useState(false);


  const handleback = (e) => {
    e.preventDefault();
    navigate(-1);
  };

  return (
    <Fade>
      <Selecttokenmod show={selecttoken} onHide={() => setselectoken(false)} />
      <Processingmodal show={processingmodal} onHide={() => setprocessingmodal(false)} title="Payment Processing"/>


      <section className="home_banner_main buy_page position-relative">
        <div className="top_circle"></div>

        <Container fluid className="position-relative container_postition">
          <Row>
            <Col lg={6} md={12} sm={12} className="m-auto">
              <div className="common_box_wrap">
                <div className="trassaction_mod_inner position-relative text-start">
                  <a
                    href="javascript:void(0)"
                    className="arrow-back d-flex align-items-center gap-2"
                    onClick={props.onhide}
                  >
                    <span className="me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 40 30"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_48_5634)">
                          <path
                            d="M3.23437 13.2344C2.25781 14.2109 2.25781 15.7969 3.23437 16.7734L15.7344 29.2734C16.7109 30.25 18.2969 30.25 19.2734 29.2734C20.25 28.2969 20.25 26.7109 19.2734 25.7344L11.0312 17.5L35 17.5C36.3828 17.5 37.5 16.3828 37.5 15C37.5 13.6172 36.3828 12.5 35 12.5L11.0312 12.5L19.2656 4.26562C20.2422 3.28906 20.2422 1.70312 19.2656 0.72656C18.2891 -0.250003 16.7031 -0.250003 15.7266 0.72656L3.22656 13.2266L3.23437 13.2344Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_48_5634">
                            <rect
                              width="30"
                              height="40"
                              fill="white"
                              transform="translate(0 30) rotate(-90)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>

                    <h4 className="m-0">Kyc Document</h4>
                  </a>

                  <div className="kyc_modal_cont">
                    <Form className="form_sign_inout mt-5">
                      <Row>
                        <Col lg={6} sm={12}>
                          <FormGroup>
                            <Label for="exampleEmail">
                              Country identity name{" "}
                            </Label>
                            <Input
                              type="text"
                              name="name"
                              id="exampleEmail"
                              placeholder="Enter identity name"
                            />
                          </FormGroup>
                        </Col>

                        <Col lg={6} sm={12}>
                          <FormGroup>
                            <Label for="idnumber">Identity number </Label>
                            <Input
                              type="number"
                              name="idnumber"
                              id="idnumber"
                              placeholder="Enter identity number "
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <div className="file_drap_here">
                        {/* <FileUploader
                        handleChange={handleChange}
                        name="file"
                        types={fileTypes}
                      /> */}

                        <div class="upload-btn-wrapper">
                          <button class="btn_upload">
                            <div className="divBtn_content text-start">
                              <h4>Country identity card </h4>
                              <p>
                                On desktop, Simply drag and drop your file in
                                this field. acceptable formats: JPEG, JPG or
                                PNG.
                              </p>
                            </div>

                            <div className="img_placeholder">
                              <img
                                src="/images/image-placeholder.png"
                                alt=""
                                className="img-fluid"
                              />
                            </div>
                          </button>
                          <input type="file" name="myfile" />
                        </div>
                      </div>

                      <Button className="btn_sign_in w-100 mt-5 btn_theme" onClick={() => setprocessingmodal(true)}>
                        Continue
                      </Button>
                    </Form>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="bottom_circle"></div>
      </section>
    </Fade>
  );
};

export default Sellkyc;
